// src/modules/components/reports/calls/CallReportsGrid.js
import React from "react";
import {
  Datagrid,
  TextField,
  DateField,
  NumberField,
  FunctionField,
} from "react-admin";
import CallTypeChip from "./CallTypeChip";
import StatusChip from "./StatusChip";

const formatDuration = (seconds) => {
  if (!seconds) return '0s';
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return mins > 0 ? `${mins}m ${secs}s` : `${secs}s`;
};

const CallReportsGrid = (props) => {
  return (
    <Datagrid
      {...props}
      rowClick={false}
      sx={{
        '& .RaDatagrid-row': {
          borderLeft: '3px solid transparent',
          '&:hover': {
            borderLeftColor: 'primary.main',
            backgroundColor: 'action.hover',
          },
        },
      }}
    >
      <DateField
        source="callDate"
        label="Time"
        showTime
        sx={{ fontWeight: 'medium', minWidth: 140 }}
      />
      <TextField
        source="src"
        label="Caller"
        sx={{ minWidth: 100 }}
        emptyText="–"
      />
      <TextField
        source="dst"
        label="Destination"
        sx={{ minWidth: 100 }}
        emptyText="–"
      />
      <FunctionField
        label="Type"
        render={(record) => <CallTypeChip record={record} />}
      />
      <FunctionField
        label="Status"
        render={(record) => <StatusChip record={record} />}
      />
      <FunctionField
        label="Duration"
        render={(record) => formatDuration(record.duration)}
      />
      <TextField
        source="agentId"
        label="Agent"
        sx={{ minWidth: 100 }}
        emptyText="–"
      />
      <NumberField
        source="qualityScore"
        label="Quality"
        emptyText="–"
      />
    </Datagrid>
  );
};

export default CallReportsGrid;